import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { AccessDeniedLogEntry, PaginationPage, PaginationResponse } from 'src/app/classes';
import { BackEndService } from 'src/app/backend-service';
import { MatTableDataSource} from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { SolveAccessDeniedIssueComponent } from '../solve-access-denied-issue/solve-access-denied-issue.component';
import { SessionService } from 'src/app/lib/shared/services/session.service';

@Component({
  selector: 'app-access-denied-log',
  templateUrl: './access-denied-log.component.html',
  styleUrls: ['./access-denied-log.component.css']
})
export class AccessDeniedLogComponent implements OnInit, AfterViewInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  displayedColumns: string[] = ['options', 'logid', 'logtime', 'logusername', 'logcomponent', 'logrules'];
  pageSize: number = 30;
  pageNumber = 1;
  dataSource = new MatTableDataSource();

  length: number = 0;

  guidFilter: string = "";

  rightsMap = {
    "read_access_prevented_log": null,
    "delete_access_prevented_log": null
  };

  constructor(
    private backEndService: BackEndService,
    private dialog: MatDialog,
    private _sessionService: SessionService
  ) { }

  applyFilter(value: string){
    this.dataSource.filter = value.toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  initRights = (soft: boolean = true) => {
    for (let index in this.rightsMap){
      this._sessionService.hasRight(index, soft).subscribe(result => this.rightsMap[index] = result);
    }
  }

  updatePageIndex(event){
    if(this.dataSource.data.length < (this.pageSize * event.pageIndex+1)){
      let pPage = new PaginationPage();
      pPage.pageSize = this.pageSize;
      pPage.pageNumber = event.pageIndex+1;
      this.backEndService.post(AccessDeniedLogEntry.url + "/pagination", pPage).subscribe((result: PaginationResponse<AccessDeniedLogEntry[]>) => {
        this.dataSource.data = result.content;
        this.pageNumber = result.page.pageNumber;
      });
    }
  }

  ngOnInit() {
    this.initRights();
    let pPage = new PaginationPage();
    pPage.pageSize = this.pageSize;
    pPage.pageNumber = this.pageNumber;
    this.backEndService.post(AccessDeniedLogEntry.url + "/pagination", pPage).subscribe((result: PaginationResponse<AccessDeniedLogEntry[]>) => {
      this.length = result.totalItems;
      this.dataSource.data = result.content;
    });
  }

  ngAfterViewInit(){
    
  }

  refresh(){
    let pPage = new PaginationPage();
    pPage.pageSize = this.pageSize;
    pPage.pageNumber = this.pageNumber;
    this.backEndService.post(AccessDeniedLogEntry.url + "/pagination", pPage).subscribe((result: PaginationResponse<AccessDeniedLogEntry[]>) => {
      this.length = result.totalItems;
      this.dataSource.data = result.content;
    });
  }

  removeDataset(entry: AccessDeniedLogEntry){
    this.backEndService.delete(AccessDeniedLogEntry.url + "/" + entry.logid).subscribe(() => {
      let i = this.dataSource.data.indexOf(entry);
      if(i > -1) this.dataSource.data.splice(i, 1);
      let pPage = new PaginationPage();
      pPage.pageSize = this.pageSize;
      pPage.pageNumber = this.pageNumber;
      this.backEndService.post(AccessDeniedLogEntry.url + "/pagination", pPage).subscribe((result: PaginationResponse<AccessDeniedLogEntry[]>) => {
        this.length = result.totalItems;
        this.dataSource.data = result.content;
      });
    });
  }

  solveIssue(entry: AccessDeniedLogEntry): void {
    const dialogRef = this.dialog.open(SolveAccessDeniedIssueComponent, {
      width: '600px',
      data: entry
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result && result.removeLogEntry){
        this.removeDataset(result.removeLogEntry);
      }
    });
  }

  splitByComma(rules: string){
    if(rules) return rules.split(",");
    return "";
  }

  Object = Object;

}
